import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import FetchResources from "./Configurations/LangConfig";


i18n
  .use(initReactI18next)
  .init({
    resources: FetchResources(),
    lng: "English",
    fallbackLng: "English",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;